export enum UserActionDescription {

    LABREQUEST_HISTORY_ICON_CLICKED = 'LABREQUEST_HISTORY_ICON_CLICKED',
    LABREQUEST_EDIT_ICON_CLICKED = 'LABREQUEST_EDIT_ICON_CLICKED',
    LABREQUEST_FACILITY_CHANGED = 'LABREQUEST_FACILITY_CHANGED',
    LABREQUEST_COLUMN_SORT = 'LABREQUEST_COLUMN_SORT',
    LABREQUEST_PAGE_NO_CLICKED = 'LABREQUEST_PAGE_NO_CLICKED',
    LABREQUEST_POPUP_CANCEL_CLICKED = 'LABREQUEST_POPUP_CANCEL_CLICKED',
    LABREQUEST_POPUP_SAVE_CLICKED = 'LABREQUEST_POPUP_SAVE_CLICKED',
    LABREQUEST_POPUP_DISCONTINUE_CLICKED = 'LABREQUEST_POPUP_DISCONTINUE_CLICKED',
    LABREQUEST_POPUP_CANCEL_CONFIRM_YES_CLICKED = 'LABREQUEST_POPUP_CANCEL_CONFIRM_YES_CLICKED',
    LABREQUEST_POPUP_CANCEL_CONFIRM_CANCEL_CLICKED = 'LABREQUEST_POPUP_CANCEL_CONFIRM_CANCEL_CLICKED',
    LABREQUEST_POPUP_DISCONTINUE_CONFIRM_YES_CLICKED = 'LABREQUEST_POPUP_DISCONTINUE_CONFIRM_YES_CLICKED',
    LABREQUEST_POPUP_DISCONTINUE_CONFIRM_CANCEL_CLICKED = 'LABREQUEST_POPUP_DISCONTINUE_CONFIRM_CANCEL_CLICKED',
    LABREQUEST_POPUP_CANCEL_ALERT_OK_CLICKED = 'LABREQUEST_POPUP_CANCEL_ALERT_OK_CLICKED',
    LABREQUEST_CREATE_NEW_REQUEST_LINK_CLICKED = 'LABREQUEST_CREATE_NEW_REQUEST_LINK_CLICKED',
    LABRESOURCE_HELP_LINK_CLICKED = 'LABRESOURCE_HELP_LINK_CLICKED',
    LABRESOURCE_HELP_SAVE_CLICKED = 'LABRESOURCE_HELP_SAVE_CLICKED',
    LABREOURCE_HELP_PREVIEW_CLICKED = 'LABREOURCE_HELP_PREVIEW_CLICKED',
    LABRESOURCE_HELP_CANCELED_CLICKED = 'LABRESOURCE_HELP_CANCELED_CLICKED',
    LABREQUEST_HISTORY_POPUP_CLOSE_CLICKED = 'LABREQUEST_HISTORY_POPUP_CLOSE_CLICKED',
    LABREQUEST_HISTORY_POPUP_PRINT_CLICKED = 'LABREQUEST_HISTORY_POPUP_PRINT_CLICKED',
    LABREQUEST_PREVIEW_LABEL_BUTTON_CLICKED = 'LABREQUEST_PREVIEW_LABEL_BUTTON_CLICKED',
    LABEL_SUMMARY_CANCELED_CLICKED = 'LABEL_SUMMARY_CANCELED_CLICKED',
    LABEL_SUMMARY_CREATE_REQUISITION_AND_PRINT_LABELS_CLICKED = 'LABEL_SUMMARY_CREATE_REQUISITION_AND_PRINT_LABELS_CLICKED',
    LABREOURCE_HELP_EDIT_HELP_CLICKED = 'LABREOURCE_HELP_EDIT_HELP_CLICKED',
    LABEL_SUMMARY_PAGE_NO_CLICKED = 'LABEL_SUMMARY_PAGE_NO_CLICKED',

    SHIPPING_MANIFEST_PENDING_TAB_CLICKED = 'SHIPPING_MANIFEST_PENDING_TAB_CLICKED',
    SHIPPING_MANIFEST_HISTORICAL_TAB_CLICKED = 'SHIPPING_MANIFEST_HISTORICAL_TAB_CLICKED',
    SHIPPING_MANIFEST_PENDING_ENTER_DRAW_DATE_CLICKED = 'SHIPPING_MANIFEST_PENDING_ENTER_DRAW_DATE_CLICKED',
    SHIPPING_MANIFEST_PENDING_ENTER_DRAW_DATE_POPUP_CANCEL_CLICKED = 'SHIPPING_MANIFEST_PENDING_ENTER_DRAW_DATE_POPUP_CANCEL_CLICKED',
    SHIPPING_MANIFEST_PENDING_ENTER_DRAW_DATE_POPUP_SAVE_CLICKED = 'SHIPPING_MANIFEST_PENDING_ENTER_DRAW_DATE_POPUP_SAVE_CLICKED',
    SHIPPING_MANIFEST_PENDING_PRINT_LABEL_CLICKED = 'SHIPPING_MANIFEST_PENDING_PRINT_LABEL_CLICKED',
    SHIPPING_MANIFEST_PENDING_PRINT_LABEL_SUMMARY_PRINT_CLICKED = 'SHIPPING_MANIFEST_PENDING_PRINT_LABEL_SUMMARY_PRINT_CLICKED',
    SHIPPING_MANIFEST_PENDING_PRINT_HOME_LABEL_SUMMARY_PRINT_CLICKED = 'SHIPPING_MANIFEST_PENDING_PRINT_HOME_LABEL_SUMMARY_PRINT_CLICKED',
    SHIPPING_MANIFEST_PENDING_PRINT_OFFICIAL_MANIFEST_CLICKED = 'SHIPPING_MANIFEST_PENDING_PRINT_OFFICIAL_MANIFEST_CLICKED',
    SHIPPING_MANIFEST_PENDING_COLUMN_SORT = 'SHIPPING_MANIFEST_PENDING_COLUMN_SORT',
    SHIPPING_MANIFEST_PENDING_PAGE_NO_CLICKED = 'SHIPPING_MANIFEST_PENDING_PAGE_NO_CLICKED',
    SHIPPING_MANIFEST_PENDING_ELLIPSES_CLICKED = 'SHIPPING_MANIFEST_PENDING_ELLIPSES_CLICKED',
    SHIPPING_MANIFEST_PENDING_ELLIPSES_CANCEL_CLICKED = 'SHIPPING_MANIFEST_PENDING_ELLIPSES_CANCEL_CLICKED',
    SHIPPING_MANIFEST_PENDING_CANCEL_REQUSITION_POPUP_CANCEL_CLICKED = 'SHIPPING_MANIFEST_PENDING_CANCEL_REQUSITION_POPUP_CANCEL_CLICKED',
    SHIPPING_MANIFEST_PENDING_CANCEL_REQUSITION_POPUP_SAVE_CLICKED = 'SHIPPING_MANIFEST_PENDING_CANCEL_REQUSITION_POPUP_SAVE_CLICKED',
    SHIPPING_MANIFEST_PENDING_ELLIPSES_ADD_TEST_TO_REQUEST_CLICKED = 'SHIPPING_MANIFEST_PENDING_ELLIPSES_ADD_TEST_TO_REQUEST_CLICKED',
    SHIPPING_MANIFEST_PENDING_ADD_TEST_TO_REQUEST_CANCEL_CLICKED = 'SHIPPING_MANIFEST_PENDING_ADD_TEST_TO_REQUEST_CANCEL_CLICKED',
    SHIPPING_MANIFEST_PENDING_ADD_TEST_TO_REQUEST_SAVE_CLICKED = 'SHIPPING_MANIFEST_PENDING_ADD_TEST_TO_REQUEST_SAVE_CLICKED',
    SHIPPING_MANIFEST_PENDING_ELLIPSES_EDIT_DRAW_DATE_CLICKED = 'SHIPPING_MANIFEST_PENDING_ELLIPSES_EDIT_DRAW_DATE_CLICKED',
    SHIPPING_MANIFEST_PENDING_ELLIPSES_PRINT_LABEL_CLICKED = 'SHIPPING_MANIFEST_PENDING_ELLIPSES_PRINT_LABEL_CLICKED',
    SHIPPING_MANIFEST_HISTORICAL_MONTH_CHANGED = 'SHIPPING_MANIFEST_HISTORICAL_MONTH_CHANGED',
    SHIPPING_MANIFEST_HISTORICAL_YEAR_CHANGED = 'SHIPPING_MANIFEST_HISTORICAL_YEAR_CHANGED',
    SHIPPING_MANIFEST_HISTORICAL_PRINT_CLICKED = 'SHIPPING_MANIFEST_HISTORICAL_PRINT_CLICKED',
    SHIPPING_MANIFEST_HISTORICAL_COLUMN_SORT = 'SHIPPING_MANIFEST_HISTORICAL_COLUMN_SORT',
    SHIPPING_MANIFEST_HISTORICAL_PAGE_NO_CLICKED = 'SHIPPING_MANIFEST_HISTORICAL_PAGE_NO_CLICKED',
    SHIPPING_MANIFEST_FACILITY_CHANGED = 'SHIPPING_MANIFEST_FACILITY_CHANGED',
    SHIPPING_MANIFEST_PENDING_EDIT_DRAW_DATE_POPUP_SAVE_CLICKED = 'SHIPPING_MANIFEST_PENDING_EDIT_DRAW_DATE_POPUP_SAVE_CLICKED',
    SHIPPING_MANIFEST_PENDING_EDIT_DRAW_DATE_POPUP_CANCEL_CLICKED = 'SHIPPING_MANIFEST_PENDING_EDIT_DRAW_DATE_POPUP_CANCEL_CLICKED',
    SHIPPING_MANIFEST_HISTORICAL_HISTORY_ICON_CLICKED = 'SHIPPING_MANIFEST_HISTORICAL_HISTORY_ICON_CLICKED',
    SHIPPING_MANIFEST_PENDING_GRID_LOADED = 'SHIPPING_MANIFEST_PENDING_GRID_LOADED',
    SHIPPING_MANIFEST_HISTORICAL_GRID_LOADED = 'SHIPPING_MANIFEST_HISTORICAL_GRID_LOADED',
    LABEL_SUMMARY_CREATE_REQUISITION_AND_PRINT_LABELS_PRINT_HOME_MANIFEST_CLICKED = 'LABEL_SUMMARY_CREATE_REQUISITION_AND_PRINT_LABELS_PRINT_HOME_MANIFEST_CLICKED',
    LABEL_SUMMARY_CREATE_REQUISITION_CLICKED = 'LABEL_SUMMARY_CREATE_REQUISITION_CLICKED',

    LABS_BY_MODEL_GRID_LOADED = 'LABS_BY_MODEL_GRID_LOADED',
    LABS_BY_MODEL_COLUMN_SORT = 'LABS_BY_MODEL_COLUMN_SORT',
    LABS_BY_MODEL_PAGE_NO_CLICKED = "LABS_BY_MODEL_PAGE_NO_CLICKED",
    LABS_BY_MODEL_EDIT_ICON_CLICKED = 'LABS_BY_MODEL_EDIT_ICON_CLICKED',
    MODIFY_ASSIGNMENT_POPUP_CANCEL_CLICKED = 'MODIFY_ASSIGNMENT_POPUP_CANCEL_CLICKED',
    MODIFY_ASSIGNMENT_POPUP_SAVE_CLICKED = 'MODIFY_ASSIGNMENT_POPUP_SAVE_CLICKED',

    LAB_FREQUENCY_ALERTS_ASSIGNMENTS_LOADED = 'LAB_FREQUENCY_ALERTS_ASSIGNMENTS_LOADED',
    LAB_FREQUENCY_ALERTS_STATE_EXCEPTIONS_GRID_LOADED = 'LAB_FREQUENCY_ALERTS_STATE_EXCEPTIONS_GRID_LOADED',
    LAB_FREQUENCY_ALERTS_ASSIGNMENTS_APPLY_CLICKED = 'LAB_FREQUENCY_ALERTS_ASSIGNMENTS_APPLY_CLICKED',
    LAB_FREQUENCY_ALERTS_STATE_EXCEPTIONS_ACTIVE_CLICKED = 'LAB_FREQUENCY_ALERTS_STATE_EXCEPTIONS_ACTIVE_CLICKED',
    LAB_FREQUENCY_ALERTS_STATE_EXCEPTIONS_COLUMN_SORT = 'LAB_FREQUENCY_ALERTS_STATE_EXCEPTIONS_COLUMN_SORT',
    LAB_FREQUENCY_ALERTS_STATE_EXCEPTIONS_PAGE_NO_CLICKED = 'LAB_FREQUENCY_ALERTS_STATE_EXCEPTIONS_PAGE_NO_CLICKED',

    LAB_RANGE_ALERTS_GRID_LOADED = 'LAB_RANGE_ALERTS_GRID_LOADED',
    LAB_RANGE_ALERTS_COLUMN_SORT = 'LAB_RANGE_ALERTS_COLUMN_SORT',
    LAB_RANGE_ALERTS_PAGE_NO_CLICKED = 'LAB_RANGE_ALERTS_PAGE_NO_CLICKED',
    
    LAB_RANGE_ALERTS_EDIT_ICON_CLICKED_ASSIGN_RANGE_OPENED = 'LAB_RANGE_ALERTS_EDIT_ICON_CLICKED_ASSIGN_RANGE_OPENED',
    LAB_RANGE_ALERTS_EDIT_ICON_CLICKED_EDIT_RANGE_OPENED = 'LAB_RANGE_ALERTS_EDIT_ICON_CLICKED_EDIT_RANGE_OPENED',
    ASSIGN_RANGE_POPUP_CANCEL_CLICKED = 'ASSIGN_RANGE_POPUP_CANCEL_CLICKED',
    EDIT_RANGE_POPUP_CANCEL_CLICKED = 'EDIT_RANGE_POPUP_CANCEL_CLICKED',
    EDIT_RANGE_POPUP_SAVE_CLICKED = 'EDIT_RANGE_POPUP_SAVE_CLICKED',
    
    ACTIVE_INACTIVE_LABS_GRID_LOADED = 'ACTIVE_INACTIVE_LABS_GRID_LOADED',
    ACTIVE_INACTIVE_LABS_ACTIVE_CLICKED = 'ACTIVE_INACTIVE_LABS_ACTIVE_CLICKED',
    ACTIVE_INACTIVE_LABS_COLUMN_SORT = 'ACTIVE_INACTIVE_LABS_COLUMN_SORT',
    ACTIVE_INACTIVE_LABS_PAGE_NO_CLICKED = 'ACTIVE_INACTIVE_LABS_PAGE_NO_CLICKED',
    ASSIGN_RANGE_POPUP_SAVE_CLICKED = 'ASSIGN_RANGE_POPUP_SAVE_CLICKED',

    LAB_RESULTS_FACILITY_CHANGED = 'LAB_RESULTS_FACILITY_CHANGED',
    LAB_RESULTS_VIEW_RESULT_BY_CHANGED = 'LAB_RESULTS_VIEW_RESULT_BY_CHANGED',
    LAB_RESULTS_APPLY_CLICKED = 'LAB_RESULTS_APPLY_CLICKED',
    LAB_RESULTS_PRINT_CLICKED = 'LAB_RESULTS_PRINT_CLICKED',
    LAB_RESULTS_VIEW_HISTORY_ICON_CLICKED = 'LAB_RESULTS_VIEW_HISTORY_ICON_CLICKED',
    LAB_RESULTS_COLUMN_SORT = 'LAB_RESULTS_COLUMN_SORT',
    LAB_RESULTS_PAGE_NO_CLICKED = 'LAB_RESULTS_PAGE_NO_CLICKED',
    LAB_RESULTS_REDRAW_CLICKED = 'LAB_RESULTS_REDRAW_CLICKED',
    LAB_RESULTS_LAB_REQUEST_HISTORY_VIEW_RESULT_BY_CHANGED = 'LAB_RESULTS_LAB_REQUEST_HISTORY_VIEW_RESULT_BY_CHANGED',
    LAB_RESULTS_LAB_REQUEST_HISTORY_COLUMN_SORT = 'LAB_RESULTS_LAB_REQUEST_HISTORY_COLUMN_SORT',
    LAB_REQUEST_LAB_REQUEST_HISTORY_COLUMN_SORT = 'LAB_REQUEST_LAB_REQUEST_HISTORY_COLUMN_SORT',
    LAB_RESULTS_LAB_REQUEST_HISTORY_PAGE_NO_CLICKED = 'LAB_RESULTS_LAB_REQUEST_HISTORY_PAGE_NO_CLICKED',
    LAB_RESULTS_LAB_REQUEST_HISTORY_PRINT_CLICKED = 'LAB_RESULTS_LAB_REQUEST_HISTORY_PRINT_CLICKED',
    LAB_RESULTS_LAB_REQUEST_HISTORY_POPUP_CLOSE_CLICKED = 'LAB_RESULTS_LAB_REQUEST_HISTORY_POPUP_CLOSE_CLICKED',
    LAB_RESULTS_LAB_REQUEST_HISTORY_APPLY_CLICKED = 'LAB_RESULTS_LAB_REQUEST_HISTORY_APPLY_CLICKED',
    LAB_RESULTS_LAB_REQUEST_HISTORY_POPUP_PRINT_CLICKED = 'LAB_RESULTS_LAB_REQUEST_HISTORY_POPUP_PRINT_CLICKED',
    LAB_REQUEST_LAB_REQUEST_HISTORY_PAGE_NO_CLICKED = 'LAB_REQUEST_LAB_REQUEST_HISTORY_PAGE_NO_CLICKED',
    LAB_REQUEST_LAB_REQUEST_HISTORY_VIEW_RESULT_BY_CHANGED = 'LAB_REQUEST_LAB_REQUEST_HISTORY_VIEW_RESULT_BY_CHANGED',
    LAB_REQUEST_LAB_REQUEST_HISTORY_APPLY_CLICKED = 'LAB_REQUEST_LAB_REQUEST_HISTORY_APPLY_CLICKED',
    LAB_RESULTS_GRID_LOADED = 'LAB_RESULTS_GRID_LOADED',


    REPORT_MENU_CLICKED = 'REPORT_MENU_CLICKED',
    RUN_REPORT_CLICKED = 'RUN_REPORT_CLICKED',

    LABREQUEST_ACTION_ITEMS_FACILITY_CHANGED = 'LABREQUEST_ACTION_ITEMS_FACILITY_CHANGED',
    LABREQUEST_ACTION_ITEMS_OVERDUE_GRID_LOADED = 'LABREQUEST_ACTION_ITEMS_OVERDUE_GRID_LOADED',
    LABREQUEST_ACTION_ITEMS_OVERDUE_HISTORY_ICON_CLICKED = 'LABREQUEST_ACTION_ITEMS_OVERDUE_HISTORY_ICON_CLICKED',
    LABREQUEST_ACTION_ITEMS_OVERDUE_PREVIEW_LABEL_BUTTON_CLICKED = 'LABREQUEST_ACTION_ITEMS_OVERDUE_PREVIEW_LABEL_BUTTON_CLICKED',
    LABREQUEST_ACTION_ITEMS_NO_LAB_REQUEST_GRID_LOADED = 'LABREQUEST_ACTION_ITEMS_NO_LAB_REQUEST_GRID_LOADED',
    LABREQUEST_ACTION_ITEMS_REDRAW_GRID_LOADED = 'LABREQUEST_ACTION_ITEMS_REDRAW_GRID_LOADED',
    LABREQUEST_ACTION_ITEMS_MISSING_DRAW_DATE_GRID_LOADED = 'LABREQUEST_ACTION_ITEMS_MISSING_DRAW_DATE_GRID_LOADED',
    LABREQUEST_ACTION_ITEMS_UPCOMING_LABS_GRID_LOADED = 'LABREQUEST_ACTION_ITEMS_UPCOMING_LABS_GRID_LOADED',
    LABREQUEST_ACTION_ITEMS_UNMAPPED_LABS_TEST_GRID_LOADED = 'LABREQUEST_ACTION_ITEMS_UNMAPPED_LABS_TEST_GRID_LOADED',
    LABREQUEST_ACTION_ITEMS_CREATE_REQUEST_CLICKED = 'LABREQUEST_ACTION_ITEMS_CREATE_REQUEST_CLICKED',
    LABREQUEST_ACTION_ITEMS_NO_LAB_REQUEST_COLUMN_SORT = 'LABREQUEST_ACTION_ITEMS_NO_LAB_REQUEST_COLUMN_SORT',
    LABREQUEST_ACTION_ITEMS_NO_LAB_REQUEST_PAGE_NO_CLICKED = 'LABREQUEST_ACTION_ITEMS_NO_LAB_REQUEST_PAGE_NO_CLICKED',
    LABREQUEST_ACTION_ITEMS_OVERDUE_COLUMN_SORT = 'LABREQUEST_ACTION_ITEMS_OVERDUE_COLUMN_SORT',
    LABREQUEST_ACTION_ITEMS_OVERDUE_PAGE_NO_CLICKED = 'LABREQUEST_ACTION_ITEMS_OVERDUE_PAGE_NO_CLICKED',
    LABREQUEST_ACTION_ITEMS_REDRAW_GRID_REDRAW_CLICKED = 'LABREQUEST_ACTION_ITEMS_REDRAW_GRID_REDRAW_CLICKED',
    LABREQUEST_ACTION_ITEMS_REDRAW_COLUMN_SORT = 'LABREQUEST_ACTION_ITEMS_REDRAW_COLUMN_SORT',
    LABREQUEST_ACTION_ITEMS_REDRAW_PAGE_NO_CLICKED = 'LABREQUEST_ACTION_ITEMS_REDRAW_PAGE_NO_CLICKED',
    LABREQUEST_ACTION_ITEMS_MISSING_DRAW_DATE_ENTER_DRAW_DATE_CLICKED = 'LABREQUEST_ACTION_ITEMS_MISSING_DRAW_DATE_ENTER_DRAW_DATE_CLICKED',
    LABREQUEST_ACTION_ITEMS_MISSING_DRAW_DATE_COLUMN_SORT = 'LABREQUEST_ACTION_ITEMS_MISSING_DRAW_DATE_COLUMN_SORT',
    LABREQUEST_ACTION_ITEMS_MISSING_DRAW_DATE_PAGE_NO_CLICKED = 'LABREQUEST_ACTION_ITEMS_MISSING_DRAW_DATE_PAGE_NO_CLICKED',
    LABREQUEST_ACTION_ITEMS_UPCOMING_LABS_GRID_PREVIEW_LABEL_CLICKED = 'LABREQUEST_ACTION_ITEMS_UPCOMING_LABS_GRID_PREVIEW_LABEL_CLICKED',
    LABREQUEST_ACTION_ITEMS_UPCOMING_LABS_COLUMN_SORT = 'LABREQUEST_ACTION_ITEMS_UPCOMING_LABS_COLUMN_SORT',
    LABREQUEST_ACTION_ITEMS_UPCOMING_LABS_PAGE_NO_CLICKED = 'LABREQUEST_ACTION_ITEMS_UPCOMING_LABS_PAGE_NO_CLICKED',
    LABREQUEST_ACTION_ITEMS_UPCOMING_LABS_HISTORY_ICON_CLICKED = 'LABREQUEST_ACTION_ITEMS_UPCOMING_LABS_HISTORY_ICON_CLICKED',

    LABREQUEST_ACTION_ITEMS_UNMAPPED_LABS_TEST_GRID_EDIT_ICON_CLICKED = 'LABREQUEST_ACTION_ITEMS_UNMAPPED_LABS_TEST_GRID_EDIT_ICON_CLICKED',
    LABREQUEST_ACTION_ITEMS_UNMAPPED_LABS_TEST_COLUMN_SORT = 'LABREQUEST_ACTION_ITEMS_UNMAPPED_LABS_TEST_COLUMN_SORT',
    LABREQUEST_ACTION_ITEMS_UNMAPPED_LABS_TEST_PAGE_NO_CLICKED = 'LABREQUEST_ACTION_ITEMS_UNMAPPED_LABS_TEST_PAGE_NO_CLICKED',
    LABS_ALERT_ALERT_ITEMS_LOADED = 'LABS_ALERT_ALERT_ITEMS_LOADED',
    LABS_ALERT_BELL_ICON_CLICKED = 'LABS_ALERT_BELL_ICON_CLICKED',
    LABS_ALERT_CLOSE_ICON_CLICKED = 'LABS_ALERT_CLOSE_ICON_CLICKED',
    LABS_ALERT_SEE_MORE_CLICKED = 'LABS_ALERT_SEE_MORE_CLICKED',
    LABS_ALERT_SEE_LESS_CLICKED = 'LABS_ALERT_SEE_LESS_CLICKED',
    LABS_ALERT_SHOW_MORE_CLICKED = 'LABS_ALERT_SHOW_MORE_CLICKED',
    LABS_ALERT_POPUP_CLOSED = 'LABS_ALERT_POPUP_CLOSED',
    

}

export enum ScreenName {
    LABREQUEST = "Lab Request Dashboard",
    RESOURCE_HELP_POPUP = "Resource Help Popup",
    EDIT_LABREQUEST = "Edit Lab Request",
    CREATE_LABREQUEST = "Create Lab Request",
    LABREQUEST_HISTORY = "Lab Request History",
    LABEL_SUMMARY = "Label Summary",
    SHIPPING_MANIFEST = "Shipping Manifest",
    ENTER_DRAW_DATE = "Enter Draw Date",
    PRINT_LABEL_SUMMARY = "Print Label Summary",
    CONFIRM_CANCELLATION = "Confirm Cancellation",
    ADDITIONAL_TEST = "Lab Request",
    EDIT_DRAW_DATE = "Edit Draw Date",
    LAB_MANAGER = "Lab Manager",
    MODIFY_ASSIGNMENT = 'Modify Assignment',
    LAB_RESULTS = "Lab Results",
    REPORT = "Report",
    LABREQUEST_ACTION_ITEMS = "Lab Request Action Items",
    LAB_ALERTES = "Lab Alert"


}


